export const FAQ_DATA = [
  {
    title: 'What is the Arré Voice Fest?',
    description:
      'The Arré Voice Fest is a set of Daily Challenges run through hashtags every day as super fun prompts that invite you to create 30-second voice pods on Arré Voice.',
  },
  {
    title: 'How do I participate?',
    description:
      "Just create a 30-second voice pod following the theme of the day and use the designated hashtag. Once you upload it to Arré Voice, you're officially in the running for that day's prizes!",
  },
  {
    title: 'What can I win?',
    description:
      "Each day, there are amazing prizes up for grabs, ranging from brand vouchers to exclusive merchandise. Keep an eye on the ‘This Month's Rewards’ section to know what you could win.",
  },
  {
    title: ' How are winners selected?',
    description:
      'Winners are picked based on the quality and creativity of their voice pods, as well as community engagement metrics like plays, likes, and shares.',
  },
  {
    title: ' When are winners announced?',
    description:
      'Winners are announced at the end of each day. Be sure to stay active on the Arré Voice app and follow us on social media to check for the big reveal!',
  },
];
